import { render } from "./CreateAcademyPage.vue?vue&type=template&id=8f23fe16"
import script from "./CreateAcademyPage.vue?vue&type=script&lang=js"
export * from "./CreateAcademyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__